import React from "react";
import { CircularProgress } from "@mui/material";
import FusionMsiWaitOverlay from "components/FusionMsiWaitOverlay";

export default ({ page, search, small = false }) => {
  if (page) {
    return <FusionMsiWaitOverlay />;
  }

  // Search/inline loading: small, absolutely positioned
  if (search) {
    return (
      <CircularProgress
        color="primary"
        size={20}
        sx={{
          position: "absolute",
          top: "4px",
          right: "0.25em",
        }}
      />
    );
  }

  // Default: simple inline loading
  return <CircularProgress color="primary" size={small ? 30 : 48} />;
};
